import { useLayoutEffect } from "react";
import { useSettings } from "../hooks/settings";

const generateHeader = () => {
  const now = new Date();
  return `[${now.toLocaleDateString()} ${now.toLocaleTimeString()}.${`000${now.getMilliseconds()}`.slice(-3)}] `;
};
const headerStyle = "color:cyan";

export const logger = {
  enable: false,
  log: function(...args: any) {
    console.log(`%c${generateHeader()}`, headerStyle, ...args);
  },
  info: function(...args: any) {
    console.info(`%c${generateHeader()}`, headerStyle, ...args);
  },
  warn: function(...args: any) {
    console.warn(`%c${generateHeader()}`, headerStyle, ...args);
  },
  error: function(...args: any) {
    console.error(`%c${generateHeader()}`, headerStyle, ...args);
  },
};

export const useLogger = () => {
  const [settings] = useSettings();
  useLayoutEffect(() => {
    logger.enable = settings.logs?.main ?? false;
  }, [settings]);
  return logger;
};
